module.exports = __webpack_public_path__ + "media/images/flags/VA-0bf5400fbe13b80c31e1b9f9eeec3ba7.svg";